import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const RecycleIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();

  const fillColor = props.color
    ? props.color === 'disabled'
      ? theme.palette.gray.light
      : props.color
    : theme.palette.red.main;

  return (
    <SvgIcon {...props} viewBox="0 0 14.007 14.007">
      <g transform="translate(4.392)">
        <path
          d="M127.017,3.173a.583.583,0,0,0-.715.413l-.278,1.037L123.517.291a.583.583,0,0,0-1.01,0l-2.028,3.5a.584.584,0,0,0,1.01.585l1.523-2.63,2,3.45-1.025-.275a.584.584,0,1,0-.3,1.127l2.386.639a.578.578,0,0,0,.155.022h.012a.577.577,0,0,0,.156-.026.56.56,0,0,0,.067-.028.592.592,0,0,0,.057-.023c.013-.007.023-.017.034-.025s.031-.021.045-.033a.58.58,0,0,0,.1-.1.536.536,0,0,0,.03-.05.591.591,0,0,0,.05-.11c0-.012.012-.021.015-.034l.641-2.392A.583.583,0,0,0,127.017,3.173Z"
          transform="translate(-120.401)"
          fill={fillColor}
        />
      </g>
      <g transform="translate(5.544 7.587)">
        <path
          d="M160.382,211.788l-2.028-3.5a.584.584,0,0,0-1.01.585l1.521,2.625h-4.874l.755-.755a.584.584,0,0,0-.825-.825l-1.751,1.751a.6.6,0,0,0-.073.089c-.01.014-.016.03-.024.045a.543.543,0,0,0-.029.056.6.6,0,0,0-.018.059c0,.017-.011.033-.015.05a.589.589,0,0,0,0,.229c0,.017.01.033.015.05a.344.344,0,0,0,.048.115c.008.015.015.03.024.045a.581.581,0,0,0,.073.089l1.751,1.751a.584.584,0,0,0,.825-.826l-.755-.755h5.887a.584.584,0,0,0,.5-.876Z"
          transform="translate(-151.998 -207.995)"
          fill={fillColor}
        />
      </g>
      <g transform="translate(0 5.545)">
        <g transform="translate(0)">
          <path
            d="M3.884,155.14a.584.584,0,0,0,.563.433.591.591,0,0,0,.151-.02.584.584,0,0,0,.413-.715l-.641-2.392a.582.582,0,0,0-.5-.428H3.847a.516.516,0,0,0-.214.022l-2.37.635a.584.584,0,0,0,.3,1.127l1.022-.274-2.5,4.321a.584.584,0,0,0,.5.876h3.5a.584.584,0,1,0,0-1.167H1.6l2-3.458Z"
            transform="translate(-0.007 -152.014)"
            fill={fillColor}
          />
        </g>
      </g>
    </SvgIcon>
  );
};
